import { SubTasksWebComponent } from './component/SubTasksWebComponent';
import { WEB_COMPONENT_NETWORK_SUB_TASKS } from '../../webcomponents.constants';
/**
 * Page component for displaying SubTasks page
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468358/Tasks+Page
 */
export { SubTasksWebComponent };
window.customElements.define(WEB_COMPONENT_NETWORK_SUB_TASKS, SubTasksWebComponent);
